import { UppKonvaShape } from '../upp-konva-shape';
import type { UppKonvaDoorShapeOptions } from '../upp-konva-options';

/** Door shape. */
export class UppKonvaDoorShape extends UppKonvaShape {
    // 1. Type contract
    readonly kind = 'DOOR' as const;

    // 2. Lifecycle
    constructor(opts: UppKonvaDoorShapeOptions) {
        const { shape, ...rest } = opts;
        super({ ...rest, data: { shape } });
    }
}
